import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthComponent } from './auth.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './auth.service';
import { routing } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { SharedModule } from '../shared/shared.module';
import { SignupComponent } from './signup/signup.component';
import { NgOtpInputModule } from  'ng-otp-input';
import { CommonService } from '../shared/common.service';
import { LandingComponent } from './landing/landing.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
@NgModule({
  imports: [CommonModule,SharedModule,routing, FormsModule, ReactiveFormsModule,NgOtpInputModule],
  declarations: [AuthComponent,LoginComponent, SignupComponent, LandingComponent, ForgetPasswordComponent],
  providers: [AuthService]
})
export class AuthModule { }
